//@flow
import CategoriesStoreClass from './categoriesStoreClass';

export default new CategoriesStoreClass();
